/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import './Business_detail.css'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import i18next from 'i18next';
import { formatMonth } from '../../formatMonth';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getPartners } from '../../../actions/partners.action';
import { getPartner } from '../../../actions/partner.action';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Preloader from '../../Preloader';
import { API_URI } from '../../../axios';
import { CiCalendar } from "react-icons/ci";
import PageHeader from '../../page-header/PageHeader';
import plane_left from '../../../assets/images/Frame_238.png'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Business_detail = () => {

    const { id } = useParams()

    const dispatch = useDispatch()
    const language = i18next.language
    const [images, setImages] = useState([])

    useEffect(() => {
        dispatch(getPartner(id, language))
        dispatch(getPartners(language))
    }, [language])

    const new_ss = useSelector(state => state.partner)

    const newsss = new_ss.partner

    const { data } = newsss

    const news_s = useSelector(state => state?.partners)

    const { partners } = news_s
    const { results } = partners
    const { t } = useTranslation()

    const formatDate = (date) => {
        const month = date.split("T")[0].split("-")[1]
        return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`
    }

    useEffect(() => {
        let slide = []
        slide.push(data?.image)
        data?.images && data?.images.length &&
            data?.images.forEach(e => {
                slide.push(e?.src)
            });
        setImages(slide)
    }, [data])

    return (
        <>
            <Helmet>
                <title>{`${t("business")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            {
                data ?
                    <div className="news-details">
                        <PageHeader
                            title={data?.title}
                            breadCrumbItems={[
                                { label: t("home"), path: '/' },
                                { label: t("business"), path: '/business' },
                                { label: data?.title, path: '#' }
                            ]}
                        />
                        <div className="container py-12">
                            <div className="row">
                                <div className="col-xl-8 col-lg-7">
                                    <div className="news-details__left p-4" style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}>

                                        <div className="flex flex-col">
                                            <div className="uppercase w-full">
                                                <p className='text-[16px] text-gray-400 flex flex-row gap-x-2 items-center'>
                                                    <CiCalendar color='#000' /> {formatDate(data.created_at)}</p>
                                            </div>
                                            <h3 className="mb-4">{data.title}</h3>
                                            <div className='w-full relative'>
                                                <Swiper
                                                    modules={[Autoplay, Pagination]}
                                                    spaceBetween={50}
                                                    slidesPerView={1}

                                                    loop={true}
                                                    autoplay={{
                                                        pauseOnMouseEnter: true,
                                                        delay: 2500,
                                                        disableOnInteraction: false,
                                                    }}
                                                    pagination={{
                                                        clickable: true
                                                    }}
                                                    scrollbar={{ draggable: true }}
                                                    className="swiper swiper-services mobileS:w-full sm:w-[70%] mx-auto"
                                                >
                                                    {
                                                        images.length ? images.map((e) => {
                                                            return (
                                                                <SwiperSlide key={e}>
                                                                    <img src={`${API_URI}${e}`} className='rounded-lg mx-auto w-full' alt="" />
                                                                </SwiperSlide>
                                                            )
                                                        }) : ''
                                                    }

                                                </Swiper>
                                                {/* <div className="flex flex-row justify-between swiper-button">
                                            <button className="absolute top-0 bottom-0 my-auto left-4 opacity-70 hover:opacity-100 duration-200 z-[50] cursor-pointer bg-[#cecece] hover:bg-[#cecece] w-[64px] h-[64px] flex flex-row justify-center items-center rounded-full" onClick={handlePrev} ><IoIosArrowBack color={"#B5BEC4"} size={22} /></button>
                                            <button className="absolute top-0 bottom-0 my-auto right-4 z-[50] opacity-70 hover:opacity-100 duration-200 cursor-pointer bg-[#cecece]  hover:bg-[#cecece] w-[64px] h-[64px] flex flex-row justify-center items-center rounded-full" onClick={handleNext} ><IoIosArrowForward color={"#B5BEC4"} size={22} /></button>
                                        </div> */}
                                            </div>
                                        </div>
                                        <div className="news-details__content my-4">
                                            <p className="news-details__text-1 font-medium" dangerouslySetInnerHTML={{ __html: data.description }}>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-5 rounded-lg">
                                    <div className="sidebar rounded-lg">
                                        <div className="sidebar__single sidebar__post">
                                            <h3 className="sidebar__title flex items-center gap-2">
                                                <div>{t("business")}</div>
                                                {/* eslint-disable-next-line jsx-a11y/alt-text */}
                                                <img src={plane_left} />
                                            </h3>
                                            <ul className="sidebar__post-list list-unstyled overflow-y-hidden">
                                                {results ?
                                                    results.slice(0, 5).map((item, index) => {
                                                        return (
                                                            item.id === Number(id) ? '' :
                                                                <React.Fragment key={index}>
                                                                    <li key={item.id} className='flex flex-row gap-x-6 justify-between'>
                                                                        <div className="w-full aspect-video min-w-[100px] max-w-[100px]">
                                                                            <img src={`${API_URI}${item.image}`} className='w-full rounded-md object-cover' alt="" />
                                                                        </div>
                                                                        <div className="sidebar__post-content">
                                                                            <h3>
                                                                                <span className="sidebar__post-content-meta capitalize"><i
                                                                                    className="fas fa-calendar"></i>{formatDate(item.created_at)}, {moment(item.created_at).format("HH:mm")}</span>
                                                                                <Link to={`/business/${item.id}`} target='_parent'>{item.title}</Link>
                                                                            </h3>
                                                                        </div>
                                                                    </li>
                                                                    {index !== results.length - 1 && <div className="w-full h-[1px] bg-[#c7c7c728] rounded-lg"></div>}
                                                                </React.Fragment>
                                                        )

                                                    })
                                                    : null
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <Preloader />
            }
        </>
    )
}

export default Business_detail